import React from 'react';
import { cn } from '../lib/utils';

export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  description?: string;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, description, id, ...props }, ref) => {
    const generatedId = React.useId();
    const switchId = id || generatedId;

    return (
      <div className="flex items-start gap-3">
        <label
          htmlFor={switchId}
          className="relative inline-flex h-6 w-11 cursor-pointer items-center rounded-full transition-colors focus-within:ring-2 focus-within:ring-brand-500 focus-within:ring-offset-2"
        >
          <input
            type="checkbox"
            id={switchId}
            className={cn('peer sr-only', className)}
            ref={ref}
            {...props}
          />
          <span className="h-6 w-11 rounded-full bg-gray-200 transition-colors peer-checked:bg-brand-500 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 dark:bg-gray-800 dark:peer-checked:bg-brand-500" />
          <span className="absolute left-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform peer-checked:translate-x-5" />
        </label>
        {(label || description) && (
          <div className="flex flex-col">
            {label && (
              <label
                htmlFor={switchId}
                className="cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                {label}
              </label>
            )}
            {description && (
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {description}
              </p>
            )}
          </div>
        )}
      </div>
    );
  }
);

Switch.displayName = 'Switch';
